import React from 'react';

import clsx from 'clsx';

import SearchIcon from '../../assets/images/searchIcon.svg';

interface SearchInputProps {
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  isDisabled?: boolean;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  placeholder,
  value,
  onChange,
  isDisabled = false,
}) => {
  return (
    <div
      className={clsx(
        'flex flex-row items-center rounded-[15px] border border-[#DBDBDB] bg-white',
        isDisabled ? 'pointer-events-none opacity-60' : ''
      )}
    >
      <img className="pb-[9px] pl-[9px] pr-[7px] pt-[9px]" src={SearchIcon} alt="search" />
      <input
        disabled={isDisabled}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full border-none font-Inter text-[16px] font-medium text-black outline-none placeholder:text-[#005FDB] placeholder:opacity-50 disabled:bg-white disabled:opacity-100 lg:w-[315px]"
      />
    </div>
  );
};
